<template>
    <div id="wrapper">
        <!-- <h1>hi</h1> -->
        <!-- <zm-input v-model="input" placeholder="input"></zm-input> -->
        <!-- <zm-row :gutter="20">
            <zm-col :span="6">
                <div class="bg-purple"></div>
            </zm-col>
            <zm-col :span="18">
                <div class=""></div>
            </zm-col>
        </zm-row> -->
        <navbar></navbar>
        <div class="super-main-container">
            <sidebar/>
            <div class="main-container">
                <breadcrumb></breadcrumb>
                <app-main class="appmain-container"/>
            </div>
            <div class="empty"></div>
        </div>
        <Footer></Footer>
        <!-- <sidebar></sidebar> -->
    </div>
</template>
<script>
import Navbar from './components/Navbar'
import Sidebar from './components/Sidebar'
import Breadcrumb from '@/components/Breadcrumb'
import AppMain from './components/AppMain'
import Footer from './components/Footer'
export default {
    name: 'layout',
    components: {
        Navbar,
        Sidebar,
        AppMain,
        Breadcrumb,
        Footer
    },
    data () {
        return {
            input: ''
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-wrapper {
    position: relative;
    height: 90%;
    width: 100%;
  }
</style>
